import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export const startEcho = () => {
  if (!window.pusherSettings) {
    return
  }

  window.Pusher = Pusher

  window.Echo = new Echo({
    broadcaster: 'pusher',
    wsHost: window.pusherSettings.host,
    wsPort: window.pusherSettings.port,
    key: window.pusherSettings.app_key,
    cluster: window.pusherSettings.cluster,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss']
  })

  // Lightweight sound registry; can be extended later
  const sounds = {
    success: new Audio('/sounds/success.mp3'),
    error: new Audio('/sounds/error.mp3'),
    info: null,
    warning: null
  }
  let lastPlayedAt = 0
  const debounceMs = 300 // prevent rapid double-plays

  const playSound = (type) => {
    const now = Date.now()
    if (now - lastPlayedAt < debounceMs) return
    lastPlayedAt = now

    const key = (type || 'info').toLowerCase()
    const audio = sounds[key] || null
    if (!audio) return

    // Attempt to play; browsers may block without user gesture
    try {
      audio.currentTime = 0
      const p = audio.play()
      if (p && typeof p.catch === 'function') {
        p.catch(() => { /* ignore autoplay errors */ })
      }
    } catch (_) { /* ignore */ }
  }

  if (window.user && window.user.id) {
    window.Echo.private('App.Models.User.' + window.user.id)
      .listen('ToastNotification', function(event) {
        window.dispatchEvent(
          new CustomEvent('notify', {
            detail: {
              message: event.message ?? '',
              title: event.title ?? '',
              type: event.type ?? 'info'
            }
          })
        )
      })
      .listen('SoundNotification', function(event) {
        // event.type contains 'success' | 'error' | ...; event.sound may override mapping
        playSound(event.sound || event.type)
      })
  }

  if (window.tenant && window.tenant.id) {
    window.Echo.private('resources.' + window.tenant.id)
      .listen('ResourceCreated', function(event) {
        console.log('ResourceCreated')
        console.log(event.resource)
        console.log(event.data)
      })
      .listen('ResourceUpdated', function(event) {
        console.log('ResourceUpdated')
        console.log(event.resource)
        console.log(event.data)
      })
  }
}
